import React from 'react';
import {UserTeamButtonProps} from "./UserTeamHeader";
import s from './UserTeamHeader.module.css';

const UserTeamFilterButton: React.FC<UserTeamButtonProps> = ({count, text, color, callback, type}) => {
    return (
        <div className={s.teamColumn}>
            <button
                onClick={() => callback(type)}
                className={s.teamButton}>
                <div className={`${s.teamIcon} ${s[`teamIcon${color.charAt(0).toUpperCase() + color.slice(1)}`]}`}>
                    {count}
                </div>
                <div className={s.teamTitle}>{text}</div>
            </button>
        </div>
    );
};

export default UserTeamFilterButton;